import { templateApi } from "@/core/data/api";

export default async (query) => {
  return await templateApi.getTemplateListPagination(query);
};
